import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../../../../Context/ThemeContext';
import { useLanguage } from '../../../../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';

import CountryCodeSelectBox from '../../../../../Component/Common/CountryCodeSelectBox';
import CustomInput from '../../../../../MemberRegistration/Component/CustomInput';
import GenderSelectBox from '../../../../../MemberRegistration/Model/GenderSelectBox';
import ProfileInput from '../../../../../MemberRegistration/Component/ProfileInput';

import { ReactComponent as InfiniteSvg } from '../../../../../image/Infinite.svg';
import { ReactComponent as CheckSvg } from '../../../../../image/Check2.svg';

export default function NewTransfereeView(props) {
  const {
    noHavePhone,
    onClickNoPhone,
    selectedCountry,
    setSelectedCountry,
    countryCodeSelectBoxRef,

    phone,
    setPhone,
    phoneErrorMsg,
    setPhoneErrorMsg,
    onClickLinkCoachIdCheck,
    isUnregisteredAfterCheck,

    name,
    setName,
    gender,
    setGender,
    birth,
    setBirth,
    profile,
    setProfile,
    userId,

    transferDays,
    transferSessions,
    handleTransferDaysChange,
    handleTransferSessionsChange,

    remainingDays,
    remainingSessions,
    isUnlimitedSessions,

    computeTransferEndDate,
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t, languageMode } = useLanguage();

  const [displayedPhoneError, setDisplayedPhoneError] = useState('');

  // 전화번호 에러 메시지 페이드아웃 처리 //
  useEffect(() => {
    if (phoneErrorMsg) setDisplayedPhoneError(phoneErrorMsg);
  }, [phoneErrorMsg]);

  return (
    <NewRegistrationView>
      <MemberInfoWrapper>
        <RowUnitWrapper width='100%' gap='10px'>
          <ColumnUnitWrapper width='100%' gap='10px'>
            <PhoneTitleWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.phone')}</Text>
              <NoHavePhoneWrapper onClick={onClickNoPhone}>
                <NoHavePhoneCheckBox isClicked={noHavePhone}>
                  {noHavePhone && <CheckIcon />}
                </NoHavePhoneCheckBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>{t('memberRegistration.noPhone')}</Text>
              </NoHavePhoneWrapper>
            </PhoneTitleWrapper>
            <PhoneInputWrapper>
              <CountryCodeSelectBox ref={countryCodeSelectBoxRef} selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} />
              <CustomInput
                value={phone}
                setValue={setPhone}
                placeholder={t('memberRegistration.phonePlaceholder')}
                disabled={noHavePhone}
                onlyNumber={true}
                flexShrink={true}
                isWarning={phoneErrorMsg}
                onFocus={() => setPhoneErrorMsg('')} />
              <FindIdButton onClick={onClickLinkCoachIdCheck}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('memberRegistration.confirm')}</Text>
              </FindIdButton>
            </PhoneInputWrapper>
            <TextWrapper width='100%' height='21px'>
              <PhoneErrorText $visible={!!phoneErrorMsg} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.pointRed} cursor='default'>{displayedPhoneError}</PhoneErrorText>
            </TextWrapper>
          </ColumnUnitWrapper>
        </RowUnitWrapper>
        <RowUnitWrapper width='100%' gap='10px' style={{ marginTop: '10px' }}>
          <ColumnUnitWrapper width='100%' gap='10px'>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.name')}</Text>
            <CustomInput
              value={name}
              setValue={setName}
              placeholder={t('memberRegistration.namePlaceholder')}
              disabled={false}
              width={181} />
          </ColumnUnitWrapper>
          <ColumnUnitWrapper width='100%' gap='10px'>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.gender')}</Text>
            <GenderSelectBox gender={gender} setGender={setGender} isColorSubKey={true} />
          </ColumnUnitWrapper>
          <ColumnUnitWrapper width='100%' gap='10px'>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.birthDate')}</Text>
            <CustomInput
              value={birth}
              setValue={setBirth}
              placeholder='YYYYMMDD'
              disabled={false}
              width={96}
              onlyNumber={true} />
          </ColumnUnitWrapper>
        </RowUnitWrapper>
        <RowUnitWrapper width='100%' gap='10px' style={{ marginTop: '15px' }}>
          <ColumnUnitWrapper gap='10px' style={{ flex: 'none', width: 'auto' }}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.profilePhoto')}</Text>
            <ProfileInput imgBase64={profile} setImgBase64={setProfile} isColorSubKey={true} />
          </ColumnUnitWrapper>
          <ColumnUnitWrapper width='100%' gap='10px' style={{ marginRight: '17px' }}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.linkoId')}</Text>
            <LinkoIdInputView>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={userId === '' ? theme.line : theme.text} cursor='default'>{userId !== '' ? userId : isUnregisteredAfterCheck ? t('memberDetail.assignModalNewMemberLabel') : t('memberRegistration.checkSignup')}</Text>
            </LinkoIdInputView>
          </ColumnUnitWrapper>
        </RowUnitWrapper>
      </MemberInfoWrapper>
      <RowUnitWrapper width='100%' gap='10px'>
        <InnerBox>
          <RowUnitWrapper width='100%' style={{ justifyContent: 'space-between' }}>
            <TextWrapper height='21px'>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.assignModalTransferPeriod')}</Text>
            </TextWrapper>
            <RowUnitWrapper gap='2px'>
              <TextWrapper height='21px'>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{remainingDays}</Text>
              </TextWrapper>
              <TextWrapper height='21px'>
                <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.assignModalDaysLeft')}</Text>
              </TextWrapper>
            </RowUnitWrapper>
          </RowUnitWrapper>
          <RowUnitWrapper width='100%' gap='5px'>
            <Input placeholder='0' value={transferDays} onChange={handleTransferDaysChange} />
            <TextWrapper height='32px'>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberDetail.assignModalDaysUnit')}</Text>
            </TextWrapper>
          </RowUnitWrapper>
          <RowUnitWrapper width='100%' gap='10px' style={{ justifyContent: 'flex-end' }}>
            <TextWrapper height='18px'>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberDetail.assignModalEndDate')}</Text>
            </TextWrapper>
            <TextWrapper height='18px'>
              <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{computeTransferEndDate()}</Text>
            </TextWrapper>
          </RowUnitWrapper>
        </InnerBox>
        <InnerBox>
          <RowUnitWrapper width='100%' style={{ justifyContent: 'space-between' }}>
            <TextWrapper height='21px'>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.assignModalTransferSessions')}</Text>
            </TextWrapper>
            {
              !isUnlimitedSessions &&
              <RowUnitWrapper gap={languageMode === 'en' ? '3px' : '0px'}>
                <TextWrapper height='21px'>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{remainingSessions}</Text>
                </TextWrapper>
                <TextWrapper height='21px'>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.assignModalSessionsLeft')}</Text>
                </TextWrapper>
              </RowUnitWrapper>
            }
          </RowUnitWrapper>
          <RowUnitWrapper width='100%' gap='5px'>
            {
              isUnlimitedSessions ?
                <StyledInfiniteWrapper>
                  <StyledInfinite />
                </StyledInfiniteWrapper>
                :
                <Input placeholder='0' value={transferSessions} onChange={handleTransferSessionsChange} />
            }
            <TextWrapper height='32px'>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberDetail.assignModalSessionsUnit')}</Text>
            </TextWrapper>
          </RowUnitWrapper>
          {
            !isUnlimitedSessions &&
            <RowUnitWrapper width='100%' gap={languageMode === 'en' ? '3px' : '0px'} style={{ justifyContent: 'flex-end' }}>
              <TextWrapper height='18px'>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{transferSessions || '0'}</Text>
              </TextWrapper>
              <TextWrapper height='18px'>
                <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.assignModalSessionsWillBeTransferred')}</Text>
              </TextWrapper>
            </RowUnitWrapper>
          }
        </InnerBox>
      </RowUnitWrapper>
    </NewRegistrationView>
  );
}

const NewRegistrationView = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 15px;
`;

const MemberInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const PhoneTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
`;

const NoHavePhoneWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 5px;

  &:hover {
    cursor: pointer;
  }
`;

const NoHavePhoneCheckBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 18px;
  height: 18px;

  border: 1px solid ${props => props.isClicked ? props.theme.subKey : props.theme.line};
  border-radius: 4px;
  background-color: ${props => props.isClicked ? props.theme.subKey : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const CheckIcon = styled(CheckSvg)`
  width: 10px;
  height: 10px;
  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const PhoneInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const FindIdButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 83px;
  height: 32px;

  border-radius: 5px;
  background-color: ${props => props.theme.subKey};

  &:hover {
    cursor: pointer;
  }
`;

const LinkoIdInputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0 10px;

  width: 100%;
  height: 32px;

  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};

  overflow: hidden;
`;

const InnerBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px;

  box-sizing: border-box;
  width: 207.5px;
  min-height: 111px;

  gap: 10px;

  border-radius: 10px;
  background-color: ${props => props.theme.thirdBackground};
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
`;

const ColumnUnitWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  ${props => props.width && `width: ${props.width};`}

  gap: ${props => props.gap};
`;

const RowUnitWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  ${props => props.width && `width: ${props.width};`}

  gap: ${props => props.gap};
`;

const Input = styled.input`
  padding: 0 10px;

  box-sizing: border-box;
  width: 100%;
  height: 32px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  outline: none;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};
  background-color: ${props => props.theme.background};

  &::placeholder {
    color: ${props => props.theme.line};
  }
`;

const StyledInfiniteWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 170.5px;
  height: 32px;
`;

const StyledInfinite = styled(InfiniteSvg)`
  width: auto;
  height: 8px;

  & path {
    fill: ${props => props.theme.text};
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  ${props => props.width && `width: ${props.width};`}
  height: ${props => props.height};
`;

const Text = styled.div`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;

const PhoneErrorText = styled(Text)`
  opacity: ${props => props.$visible ? 1 : 0};

  transition: opacity 0.3s ease-in-out;
`;
